(function () {
  var svgNamespace = 'http://www.w3.org/2000/svg';
  var centerX = 230;
  var centerY = 230;
  var innerRadius = 78;
  var outerRadius = 200;

  function polar(cx, cy, radius, degrees) {
    var radians = (degrees - 90) * Math.PI / 180;
    return [cx + radius * Math.cos(radians), cy + radius * Math.sin(radians)];
  }

  function arcPath(cx, cy, radiusInner, radiusOuter, startDegrees, endDegrees) {
    var outerStart = polar(cx, cy, radiusOuter, startDegrees);
    var outerEnd = polar(cx, cy, radiusOuter, endDegrees);
    var innerEnd = polar(cx, cy, radiusInner, endDegrees);
    var innerStart = polar(cx, cy, radiusInner, startDegrees);
    var largeArc = endDegrees - startDegrees > 180 ? 1 : 0;

    return [
      'M', outerStart[0], outerStart[1],
      'A', radiusOuter, radiusOuter, 0, largeArc, 1, outerEnd[0], outerEnd[1],
      'L', innerEnd[0], innerEnd[1],
      'A', radiusInner, radiusInner, 0, largeArc, 0, innerStart[0], innerStart[1],
      'Z'
    ].join(' ');
  }

  function svgElement(name, attributes) {
    var element = document.createElementNS(svgNamespace, name);
    Object.keys(attributes || {}).forEach(function (key) {
      element.setAttribute(key, attributes[key]);
    });
    return element;
  }

  function textLength(node, text) {
    node.textContent = text;

    try {
      return node.getComputedTextLength();
    } catch (error) {
      return String(text).length * 8;
    }
  }

  function clearNode(node) {
    while (node.firstChild) {
      node.removeChild(node.firstChild);
    }
  }

  function splitCenterLabel(labelNode, label, maxWidth, maxLines) {
    var words = String(label || '').trim().split(/\s+/).filter(Boolean);
    var lines = [];
    var current = '';

    if (!words.length) return [''];

    words.forEach(function (word) {
      var candidate = current ? current + ' ' + word : word;

      if (!current || textLength(labelNode, candidate) <= maxWidth) {
        current = candidate;
      } else {
        lines.push(current);
        current = word;
      }
    });

    if (current) lines.push(current);

    if (lines.length > maxLines) {
      lines = lines.slice(0, maxLines - 1).concat(lines.slice(maxLines - 1).join(' '));
    }

    return lines;
  }

  function renderCenterLabel(labelNode, lines, fontSize) {
    var lineHeight = fontSize * 1.18;
    var firstBaseline = centerY - 4 - ((lines.length - 1) * fontSize * 0.62);

    clearNode(labelNode);
    labelNode.style.fontSize = fontSize + 'px';
    labelNode.setAttribute('x', centerX);
    labelNode.setAttribute('y', firstBaseline);

    lines.forEach(function (line, index) {
      var tspan = svgElement('tspan', {
        x: centerX,
        dy: index === 0 ? '0' : lineHeight
      });
      tspan.textContent = line;
      labelNode.appendChild(tspan);
    });

    return firstBaseline + ((lines.length - 1) * lineHeight);
  }

  function maxLineLength(labelNode) {
    return Array.prototype.reduce.call(labelNode.querySelectorAll('tspan'), function (max, tspan) {
      try {
        return Math.max(max, tspan.getComputedTextLength());
      } catch (error) {
        return Math.max(max, String(tspan.textContent || '').length * 8);
      }
    }, 0);
  }

  function truncateLine(labelNode, line, maxWidth) {
    var shortened = String(line || '');

    if (textLength(labelNode, shortened) <= maxWidth) return shortened;

    while (shortened.length > 3 && textLength(labelNode, shortened + '...') > maxWidth) {
      shortened = shortened.slice(0, -1);
    }

    return shortened.length > 3 ? shortened + '...' : shortened;
  }

  function setCenterText(svg, label, sublabel) {
    var labelNode = svg.querySelector('[data-wheel-center-label]');
    var subNode = svg.querySelector('[data-wheel-center-sub]');
    var maxWidth = 132;
    var fontSize = 12;
    var lines;
    var lastBaseline;

    if (labelNode) {
      labelNode.style.fontSize = fontSize + 'px';
      lines = splitCenterLabel(labelNode, label, maxWidth, 2);
      lastBaseline = renderCenterLabel(labelNode, lines, fontSize);

      if (maxLineLength(labelNode) > maxWidth) {
        lines = lines.map(function (line) {
          return truncateLine(labelNode, line, maxWidth);
        });
        lastBaseline = renderCenterLabel(labelNode, lines, fontSize);
      }
    }

    if (subNode) {
      subNode.textContent = sublabel;
      subNode.setAttribute('y', (lastBaseline || centerY - 4) + 20);
    }
  }

  function drawWheel(stage) {
    if (stage.dataset.wheelReady === 'true') return;
    stage.dataset.wheelReady = 'true';

    var svg = stage.querySelector('[data-fragrance-wheel-svg]');
    var dataNode = stage.querySelector('[data-fragrance-wheel-json]');
    if (!svg || !dataNode) return;

    var families = [];
    try {
      families = JSON.parse(dataNode.textContent || '[]').filter(function (item) {
        return item && item.name && item.handle;
      });
    } catch (error) {
      families = [];
    }

    svg.textContent = '';

    var defaultLabel = stage.dataset.defaultLabel || 'Fragrance Wheel';
    var totalProducts = families.reduce(function (sum, item) {
      return sum + Math.max(Number(item.count) || 0, 0);
    }, 0);
    var displayTotal = Number(stage.dataset.totalOils) || totalProducts;
    var displayFamilies = Number(stage.dataset.familyCount) || families.length;
    var defaultSub = displayTotal + ' oils, ' + displayFamilies + ' families';

    if (!families.length) {
      defaultSub = stage.dataset.emptyText || 'Add collections in the customizer';
    }

    var weightTotal = families.reduce(function (sum, item) {
      return sum + Math.max(Number(item.count) || 0, 1);
    }, 0) || families.length || 1;
    var angle = -90;

    families.forEach(function (family) {
      var count = Math.max(Number(family.count) || 0, 1);
      var sweep = count / weightTotal * 360;
      var start = angle;
      var end = angle + sweep;
      var path = svgElement('path', {
        class: 'wheel-wheel__seg',
        d: arcPath(centerX, centerY, innerRadius, outerRadius, start, end),
        fill: family.color || '#c17f3b',
        stroke: 'var(--wheel-cream)',
        'stroke-width': '3',
        tabindex: '0',
        role: 'link',
        'aria-label': family.name
      });

      path.addEventListener('mouseenter', function () {
        setCenterText(svg, family.name, (Number(family.count) || 0) + ' oils');
        svg.querySelectorAll('.wheel-wheel__seg').forEach(function (segment) {
          segment.classList.toggle('dim', segment !== path);
        });
      });

      path.addEventListener('mouseleave', function () {
        setCenterText(svg, defaultLabel, defaultSub);
        svg.querySelectorAll('.wheel-wheel__seg').forEach(function (segment) {
          segment.classList.remove('dim');
        });
      });

      path.addEventListener('focus', function () {
        setCenterText(svg, family.name, (Number(family.count) || 0) + ' oils');
      });

      path.addEventListener('blur', function () {
        setCenterText(svg, defaultLabel, defaultSub);
      });

      path.addEventListener('click', function () {
        if (family.url) window.location.href = family.url;
      });

      path.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          path.click();
        }
      });

      svg.appendChild(path);
      angle = end;
    });

    svg.appendChild(svgElement('circle', {
      cx: centerX,
      cy: centerY,
      r: innerRadius - 2,
      fill: 'var(--wheel-cream-2)',
      stroke: 'var(--wheel-line)',
      'stroke-width': '1'
    }));

    var label = svgElement('text', {
      class: 'wheel-center-label',
      x: centerX,
      y: centerY - 4,
      'data-wheel-center-label': ''
    });
    label.textContent = defaultLabel;
    svg.appendChild(label);

    var sub = svgElement('text', {
      class: 'wheel-center-sub',
      x: centerX,
      y: centerY + 16,
      'data-wheel-center-sub': ''
    });
    svg.appendChild(sub);

    setCenterText(svg, defaultLabel, defaultSub);
  }

  function initPreview(preview) {
    if (preview.dataset.previewReady === 'true') return;
    preview.dataset.previewReady = 'true';

    var buttons = preview.querySelectorAll('[data-wheel-filter]');
    var cards = preview.querySelectorAll('[data-wheel-product-card]');
    var empty = preview.querySelector('[data-wheel-preview-empty]');

    function applyFilter(filter) {
      var shown = 0;

      cards.forEach(function (card) {
        var values = (card.dataset.wheelFilters || '').split(/\s+/).filter(Boolean);
        var visible = filter === 'all' || values.indexOf(filter) !== -1;
        card.classList.toggle('is-hidden', !visible);
        if (visible) shown += 1;
      });

      if (empty) empty.hidden = shown > 0;
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        buttons.forEach(function (other) {
          other.classList.remove('active');
          other.setAttribute('aria-pressed', 'false');
        });

        button.classList.add('active');
        button.setAttribute('aria-pressed', 'true');
        applyFilter(button.dataset.wheelFilter || 'all');
      });
    });

    applyFilter('all');
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-fragrance-wheel]').forEach(drawWheel);
    (scope || document).querySelectorAll('[data-wheel-preview]').forEach(initPreview);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
